import { render, staticRenderFns } from "./ManagedAcademiesStats.vue?vue&type=template&id=0c25eca0&scoped=true"
import script from "./ManagedAcademiesStats.vue?vue&type=script&lang=js"
export * from "./ManagedAcademiesStats.vue?vue&type=script&lang=js"
import style0 from "./ManagedAcademiesStats.vue?vue&type=style&index=0&id=0c25eca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25eca0",
  null
  
)

export default component.exports